import type { TrTheme } from '@core/plugins/vuetify/theme/theme.interface'
import { Theme as LightTheme } from '@/config/themes/light/theme'
import { Theme as DarkTheme } from '@/config/themes/dark/theme'

export const ProjectThemes: TrTheme[] = [LightTheme, DarkTheme]
